import FormTextInput from "../../components/inputs/texts/form.text.input";
import FormSelectionInput from "../../components/inputs/selections/form.selection.input";
import FormDatePickerInput from "../../components/inputs/dates/form.datePicker.input";
import FormNumberInput from "../../components/inputs/numbers/form.number.input";
import MultiSelectInput from "../../components/inputs/selections/multi/old.multi.select.input";

const useReturnFormComponents = () => {
  const getFormComponent = (field, index) => {
    switch (field.type) {
      case "text":
        return <FormTextInput key={index} {...field.props} />;
      case "selection":
        return <FormSelectionInput key={index} {...field.props} />;
      case "date":
        return <FormDatePickerInput key={index} {...field.props} />;
      case "number":
        return <FormNumberInput key={index} {...field.props} />;
      case "multiSelect":
        return <MultiSelectInput key={index} {...field.props} />;
      default:
        console.log(`Error: Invalid field type: ${field.type}`);
        return null;
    }
  };

  const getFormComponents = ({ fields = [] }) => {
    if (!fields || fields.length === 0) return null;
    return fields.map((field, index) => getFormComponent(field, index));
  };

  return { getFormComponents };
};

export default useReturnFormComponents;
